import { TicketAttachmentDescriptor, TicketAttachmentType } from './tickets-api.models';

/**
 * Support tickets with files are created through the multipart `POST /v2/support/tickets`
 * endpoint: file bytes go up as `files` parts, and only their metadata is
 * described inside the JSON `data` part. These helpers build that metadata
 * from the picked `File` objects so callers never have to base64-encode.
 */

export function getFileExtension(fileName: string): string {
  const parts = fileName.split('.');
  return parts.length > 1 ? (parts[parts.length - 1] ?? '').toLowerCase() : '';
}

export function resolveTicketAttachmentType(file: File): TicketAttachmentType {
  const contentType = (file.type || '').toLowerCase();

  if (contentType.startsWith('video/')) {
    return 'VIDEO';
  }

  // Some browsers report an empty MIME type; fall back to the extension.
  if (['mp4', 'mov', 'avi', 'mkv', 'webm'].includes(getFileExtension(file.name))) {
    return 'VIDEO';
  }

  return 'IMAGE';
}

export function describeTicketAttachment(
  file: File,
  attachmentType: TicketAttachmentType = resolveTicketAttachmentType(file),
): TicketAttachmentDescriptor {
  return {
    fileName: file.name,
    extension: getFileExtension(file.name),
    contentType: file.type || 'application/octet-stream',
    attachmentType,
  };
}
